import React, { useState } from "react";

export default function AboutPageAdminSection({
  lang,
  aboutPage,
  setAboutPage,
  saveAboutPage
}) {
  const [showFactModal, setShowFactModal] = useState(false);
  const [editingFactIdx, setEditingFactIdx] = useState(null);
  const [factDraft, setFactDraft] = useState({ title: "", description: "" });

  if (!aboutPage) return null;

  const openAddFactModal = () => {
    setEditingFactIdx(null);
    setFactDraft({ title: "", description: "" });
    setShowFactModal(true);
  };

  const openEditFactModal = (idx) => {
    setEditingFactIdx(idx);
    setFactDraft(aboutPage.interestingFacts[idx]);
    setShowFactModal(true);
  };

  const handleSaveFact = () => {
    let updatedFacts = [...(aboutPage.interestingFacts || [])];
    if (editingFactIdx === null) {
      updatedFacts.push(factDraft);
    } else {
      updatedFacts[editingFactIdx] = factDraft;
    }
    setAboutPage({ ...aboutPage, interestingFacts: updatedFacts });
    setShowFactModal(false);
    setEditingFactIdx(null);
    setFactDraft({ title: "", description: "" });
  };

  const handleDelete = (idx) => {
    const updated = aboutPage.interestingFacts.filter((_, i) => i !== idx);
    setAboutPage({ ...aboutPage, interestingFacts: updated });
    setShowFactModal(false);
    setEditingFactIdx(null);
    setFactDraft({ title: "", description: "" });
  };

  return (
    <section className="section">
      <h2 className="sectionTitle">About Page ({lang})</h2>
      <div
        className="aboutPageBlock"
        style={{
          background: "#f8fafc",
          borderRadius: 12,
          padding: "2rem",
          boxShadow: "0 2px 8px #0001",
          display: "flex",
          flexDirection: "column",
          gap: "2.5rem"
        }}
      >
        {/* Hero */}
        <div>
          <h3 className="sectionTitle" style={{ fontSize: "1.15rem", marginBottom: 12 }}>Hero</h3>
          <div className="formRow" style={{ gap: 16, alignItems: "flex-start" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <label className="label" style={{ marginBottom: 4 }}>Título</label>
              <input
                name="title"
                value={aboutPage.hero?.title || ""}
                onChange={e => setAboutPage({
                  ...aboutPage,
                  hero: { ...aboutPage.hero, title: e.target.value }
                })}
                placeholder="Título principal"
                className="input"
              />
            </div>
            <div style={{ flex: 2, display: "flex", flexDirection: "column" }}>
              <label className="label" style={{ marginBottom: 4 }}>Descripción</label>
              <textarea
                name="description"
                value={aboutPage.hero?.description || ""}
                onChange={e => setAboutPage({
                  ...aboutPage,
                  hero: { ...aboutPage.hero, description: e.target.value }
                })}
                placeholder="Descripción corta"
                className="input"
                rows={5}
                style={{ resize: "vertical", width: "100%", minHeight: 80, boxSizing: "border-box" }}
              />
            </div>
          </div>
        </div>

        {/* Datos de Interés */}
        <div>
          <h3 className="sectionTitle" style={{ fontSize: "1.15rem", marginBottom: 12 }}>Datos de Interés</h3>
          <button
            onClick={openAddFactModal}
            className="button"
            style={{ marginBottom: 16 }}
          >Agregar dato de interés</button>
          <ul className="list listColumn">
            {(aboutPage.interestingFacts || []).length === 0 && (
              <div style={{ color: "#888", marginBottom: 8 }}>No hay datos de interés cargados.</div>
            )}
            {(aboutPage.interestingFacts || []).map((fact, idx) => (
              <li key={idx} className="listItem" style={{ justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <b>{fact.title}</b>
                  {fact.description && (
                    <>
                      {" - "}
                      <span style={{ color: "#444" }}>{fact.description}</span>
                    </>
                  )}
                </div>
                <div>
                  <button
                    className="iconBtn"
                    title="Editar"
                    onClick={() => openEditFactModal(idx)}
                    style={{ marginRight: 6 }}
                  >✏️</button>
                  <button
                    onClick={() => handleDelete(idx)}
                    className="buttonDanger"
                  >X</button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Guardar */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={saveAboutPage}
            className="button"
            style={{ minWidth: 180 }}
          >
            Guardar About Page
          </button>
        </div>
      </div>

      {/* === MODAL (Agregar/Editar Dato de Interés) === */}
      {showFactModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#fff", borderRadius: 10, padding: 32, minWidth: 350, maxWidth: 500, width: "100%",
            boxShadow: "0 4px 32px #0002", display: "flex", flexDirection: "column", gap: 16
          }}>
            <h3 style={{ margin: 0 }}>{editingFactIdx !== null ? "Editar dato de interés" : "Agregar dato de interés"}</h3>
            <input
              className="input"
              placeholder="Título"
              value={factDraft.title}
              onChange={e => setFactDraft({ ...factDraft, title: e.target.value })}
            />
            <textarea
              className="input"
              placeholder="Descripción"
              value={factDraft.description}
              onChange={e => setFactDraft({ ...factDraft, description: e.target.value })}
              rows={4}
              style={{ resize: "vertical" }}
            />
            <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
              <button className="button" onClick={handleSaveFact}>
                {editingFactIdx !== null ? "Guardar cambios" : "Agregar"}
              </button>
              <button className="buttonDanger" onClick={() => setShowFactModal(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}